let modal
let titleElement
let cancelButton
let confirmButton
let resolveConfirmation
let returnFocus
let inertElements = []

function buildModal() {
  modal = document.createElement("div")
  modal.className = "confirmation-modal"
  modal.hidden = true
  modal.setAttribute("role", "dialog")
  modal.setAttribute("aria-modal", "true")
  modal.setAttribute("aria-labelledby", "confirmation-modal-title")
  modal.innerHTML = `
    <div class="confirmation-modal-panel">
      <h2 id="confirmation-modal-title" class="confirmation-modal-title"></h2>
      <div class="confirmation-modal-actions">
        <button type="button" class="button button-secondary">Zrušit</button>
        <button type="button" class="button button-primary">Potvrdit</button>
      </div>
    </div>
  `
  const buttons = modal.querySelectorAll("button")
  cancelButton = buttons[0]
  confirmButton = buttons[1]
  titleElement = modal.querySelector("#confirmation-modal-title")
  cancelButton.addEventListener("click", () => settle(false))
  confirmButton.addEventListener("click", () => settle(true))
  modal.addEventListener("click", event => {
    if (event.target === modal) settle(false)
  })
  modal.addEventListener("keydown", trapKeyboard)
  document.body.append(modal)
}

function trapKeyboard(event) {
  if (event.key === "Escape") {
    event.preventDefault()
    settle(false)
    return
  }
  if (event.key !== "Tab") return

  const first = cancelButton
  const last = confirmButton
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault()
    last.focus()
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault()
    first.focus()
  }
}

function keepFocusInside(event) {
  if (resolveConfirmation && !modal.contains(event.target)) cancelButton.focus()
}

function settle(answer) {
  if (!resolveConfirmation) return

  const resolve = resolveConfirmation
  resolveConfirmation = undefined
  modal.hidden = true
  document.removeEventListener("focusin", keepFocusInside)
  inertElements.forEach(element => { element.inert = false })
  inertElements = []
  document.body.classList.remove("confirmation-modal-open")
  if (returnFocus?.isConnected) returnFocus.focus()
  returnFocus = undefined
  resolve(answer)
}

export function confirmAction(message) {
  if (resolveConfirmation) settle(false)
  if (!modal?.isConnected) buildModal()

  titleElement.textContent = message
  returnFocus = document.activeElement
  inertElements = Array.from(document.body.children).filter(element => element !== modal && !element.inert)
  inertElements.forEach(element => { element.inert = true })
  modal.hidden = false
  document.body.classList.add("confirmation-modal-open")
  document.addEventListener("focusin", keepFocusInside)

  return new Promise(resolve => {
    resolveConfirmation = resolve
    cancelButton.focus()
  })
}

function removeModal() {
  settle(false)
  modal?.remove()
  modal = undefined
}

document.addEventListener("turbo:before-cache", removeModal)
document.addEventListener("turbo:before-render", removeModal)
